export default "__VITE_ASSET__BgH0y$Mj__"